import type { ClaimFeatureItem, CompareFeatureItem, ExcelParams } from '../types';

export const ExportExcelService = Symbol.for('ExportExcelService');

export interface ExportExcelService {
    exportCompareExcel(data: CompareFeatureItem[], tableInfo: ExcelParams): Promise<void>;
    exportClaimExcel(data: ClaimFeatureItem[], tableInfo: ExcelParams): Promise<void>; 
}